export {
	PHONE_PREVIEW_OVERLAY_SLOT_ID,
	PHONE_PREVIEW_STATUS_BAR_BACKGROUND_SLOT_ID,
	PhonePreview,
} from './PhonePreview'
